import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import api from './services/api.js'
import '@/assets/css/nucleo-icons.css'
import '@/assets/css/nucleo-svg.css'
import '@/assets/css/soft-ui-dashboard.css'
import '@/assets/scss/modern-styles.scss'
import '@/assets/scss/modern-overrides.scss'
import '@/assets/scss/mobile-adaptation.scss'
import '@/assets/scss/modals.scss'

// Делаем axios доступным глобально для push-client.js
window.axios = api

createApp(App).use(store).use(router).mount('#app')
